"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostcodeLocationResponse$ = exports.PostcodeLocationResponse$outboundSchema = exports.PostcodeLocationResponse$inboundSchema = void 0;
exports.postcodeLocationResponseToJSON = postcodeLocationResponseToJSON;
exports.postcodeLocationResponseFromJSON = postcodeLocationResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const postcodelocationwrapper_js_1 = require("./postcodelocationwrapper.js");
/** @internal */
exports.PostcodeLocationResponse$inboundSchema = z.object({
    data: postcodelocationwrapper_js_1.PostcodeLocationWrapper$inboundSchema,
});
/** @internal */
exports.PostcodeLocationResponse$outboundSchema = z.object({
    data: postcodelocationwrapper_js_1.PostcodeLocationWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostcodeLocationResponse$;
(function (PostcodeLocationResponse$) {
    /** @deprecated use `PostcodeLocationResponse$inboundSchema` instead. */
    PostcodeLocationResponse$.inboundSchema = exports.PostcodeLocationResponse$inboundSchema;
    /** @deprecated use `PostcodeLocationResponse$outboundSchema` instead. */
    PostcodeLocationResponse$.outboundSchema = exports.PostcodeLocationResponse$outboundSchema;
})(PostcodeLocationResponse$ || (exports.PostcodeLocationResponse$ = PostcodeLocationResponse$ = {}));
function postcodeLocationResponseToJSON(postcodeLocationResponse) {
    return JSON.stringify(exports.PostcodeLocationResponse$outboundSchema.parse(postcodeLocationResponse));
}
function postcodeLocationResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostcodeLocationResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostcodeLocationResponse' from JSON`);
}
//# sourceMappingURL=postcodelocationresponse.js.map